import { ProjectTemplateData } from 'data/templates/projects';
import { IsColumnFuncParams } from '../types';

export const editable = (params: Pick<IsColumnFuncParams, 'node'>): boolean => {
  const nodes = params.node.childrenAfterGroup ?? [];
  const templateData = nodes.map((node) => node.data) as ProjectTemplateData[];
  const existingNodes = templateData.filter((data) => !data.data.isNew);
  const hasExistingNodes = existingNodes.length > 0;

  return !hasExistingNodes;
};
